import * as url from 'url';
export const urlEncode = window.encodeURIComponent;
export const urlDecode = window.decodeURIComponent;
export const urlParse = url.parse;
export const urlFormat = url.format;
export const urlResolve = url.resolve;
